import * as colors from "@vitalsource/vstui/colors";
import { createTheme } from "@vitalsource/vstui/themes";
import { selectors as brandSelectors } from "../brand";
import * as types from "../brand/types";

const theme = createTheme({
  breakpoint: {
    xs: "(min-width: 480px)"
  },
  color: {
    primary: colors["ocean"],
    secondary: colors["ocean"]
  },
  size: {
    large: 44,
    medium: 32,
    small: 28
  },
  typography: {
    htmlFontSize: 10
  }
});

const reducer = (state = theme, action) => {
  switch (action.type) {
    case types.BRAND_UPDATED:
      return createTheme({
        ...state.vstui,
        color: {
          primary:
            colors[
              brandSelectors.getBrandValue(
                action,
                "theme.primary",
                state.vstui.color.primary
              )
            ],
          secondary:
            colors[
              brandSelectors.getBrandValue(
                action,
                "theme.secondary",
                state.vstui.color.secondary
              )
            ]
        }
      });
    default:
      return state;
  }
};

export { reducer };
